import React from 'react';
import { OfferState } from '../../../../../../services/offersService';
import useOffer from '../../../../store/offer/useOffer';
import { EXCLUDED_CALCULATION_SPECS } from '../../offer-actions/OfferParametersChangeAction';
import { handleResponseLanguage } from '../../../../../../../../../i18n';
import { CalculationSpec } from '../../../../../../../../../types/Quotes';
import { toEuro } from '../../../../../../utils/stringUtils';
import LabeledParamFallback from '../../../../../../../../common/src/components/label-param-fallback/LabelParamFallback';

const BoatOfferDetails: React.FC = () => {
  const { offer } = useOffer();
  const filteredSpecs = offer.details?.calculation_specs?.filter(
    ({ calc_type }) => !EXCLUDED_CALCULATION_SPECS.includes(calc_type),
  );

  if (offer.state === OfferState.ERROR) return null;

  const getCorrectValue = (spec: CalculationSpec) => {
    switch (spec.input_type) {
      case 'CURRENCY':
        return spec.value ? toEuro(spec.value, offer.premium?.currency) : null;
      case 'SELECT': {
        const enumOption = spec.enum?.find(
          ({ value }) => value === spec.value?.toString(),
        );
        return <>{enumOption?.label}</>;
      }
      default:
        return spec.value;
    }
  };

  return (
    <>
      {filteredSpecs?.map((spec) => (
        <LabeledParamFallback
          label={handleResponseLanguage(spec.title)}
          key={handleResponseLanguage(spec.title)}
        >
          {getCorrectValue(spec)}
        </LabeledParamFallback>
      ))}
    </>
  );
};

export default BoatOfferDetails;
